import {Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {Subscription} from "rxjs";
import {SocketService} from "../../_services/socket.service";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import {CommunitiesService} from "../../_services/communities.service";

@Component({
    selector: 'app-online-status-badge',
    templateUrl: './online-status-badge.component.html',
    styleUrl: './online-status-badge.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OnlineStatusBadgeComponent implements OnInit, OnDestroy {
    @Input() userId: number = 0;
    @Input() isStaff: boolean | undefined = false;
    isOnline: boolean = false;
    hide: boolean | undefined = false;
    private subscription: Subscription | undefined;

    constructor(private socketService: SocketService,
                private communitiesService: CommunitiesService,) {
        this.communitiesService.getCurrentDashboardCommunity()
            .pipe(takeUntilDestroyed())
            .subscribe(community => {
                this.hide = community?.disable_online_icon_next_to_profile_picture;
            });
    }

    ngOnInit(): void {
        this.subscription = this.socketService
            .isUserOnline(this.userId)
            .subscribe(online => {
                this.isOnline = online;
            });
    }

    ngOnDestroy(): void {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
}
